import { render, staticRenderFns } from "./VehicleOrganizationFeatures.vue?vue&type=template&id=1df3f5bd&scoped=true"
import script from "./VehicleOrganizationFeatures.vue?vue&type=script&lang=js"
export * from "./VehicleOrganizationFeatures.vue?vue&type=script&lang=js"
import style0 from "./VehicleOrganizationFeatures.vue?vue&type=style&index=0&id=1df3f5bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3f5bd",
  null
  
)

export default component.exports